module.exports = __webpack_public_path__ + "img/japan-colorectal-cancer-male.18b22743.png";